(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ReleveCompteurSearch', ReleveCompteurSearch);

    ReleveCompteurSearch.$inject = ['$resource'];

    function ReleveCompteurSearch($resource) {
        var resourceUrl =  'api/releve-compteur/search/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
